import { render, staticRenderFns } from "./BilgiGuncelleme.vue?vue&type=template&id=e11f4b24&scoped=true"
import script from "./BilgiGuncelleme.vue?vue&type=script&lang=js"
export * from "./BilgiGuncelleme.vue?vue&type=script&lang=js"
import style0 from "./BilgiGuncelleme.vue?vue&type=style&index=0&id=e11f4b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11f4b24",
  null
  
)

export default component.exports